import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { ApiService } from '@services/api.service';

import { LineModel } from '@data-layer/models/entry-summaries';

// Backend rejects bulk-delete batches above this size (400 too_many_line_items).
export const LINE_ITEMS_BULK_DELETE_LIMIT: number = 500;

@Injectable({
  providedIn: 'root',
})
export class LineItemsRepository {
  constructor(private apiService: ApiService) {}

  public get(itemId: number): Observable<LineModel> {
    return this.apiService.get<LineModel>(`${environment.url.prefixCustoms}v2/line-items/${itemId}/`);
  }

  public update(
    itemId: number,
    item: Partial<LineModel>,
    customErrorHandlerFunction?: (err: HttpErrorResponse) => Observable<never>,
  ): Observable<LineModel> {
    return this.apiService.put<LineModel>(
      `${environment.url.prefixCustoms}v2/line-items/${itemId}`,
      item,
      undefined,
      undefined,
      customErrorHandlerFunction,
    );
  }

  public delete(itemId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/line-items/${itemId}`);
  }

  // Atomic: the whole batch is validated first, nothing is deleted if any id is invalid.
  public bulkDelete(ids: number[]): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/line-items/bulk-delete`, ids);
  }

  public create(invoiceId: number, item: Partial<LineModel>): Observable<LineModel> {
    return this.apiService.post<LineModel>(`${environment.url.prefixCustoms}v2/invoices/${invoiceId}/line-items`, item);
  }
}
